export default __webpack_public_path__ + "static/media/check-bg-small.c7113a64.svg";